var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[_c('div',{staticClass:"cp"},[_c('p',[_c('b',[_vm._v("© Klas Wärnå")])])])])
}]

export { render, staticRenderFns }